// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".battery-module_555b .icon_4359 {\n  display: inline;\n  padding-left: 0.25rem;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/Observe/BatteryModule.scss","BatteryModule.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,qBAAA;ACAR","file":"BatteryModule.scss","sourcesContent":[".battery-module {\n    .icon {\n        display: inline;\n        padding-left: 0.25rem;\n    }\n}",".battery-module .icon {\n  display: inline;\n  padding-left: 0.25rem;\n}"]}]);
// Exports
exports.locals = {
	"battery-module": "battery-module_555b",
	"icon": "icon_4359"
};
module.exports = exports;
